import { DEFAULTS } from "./defaults";
import { DIVIDER_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers";
const pluginDivider = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: DIVIDER_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginDivider
};
//# sourceMappingURL=viewer.js.map
